export const DocumentType = {
    SPECIFICATIONS: "SPECIFICATIONS",
    LAUNCH_NOTE: "LAUNCH_NOTE",
    ATTRIBUTION: "ATTRIBUTION",
    ATTRIBUTION_NOTIFICATION_UNSIGNED: "ATTRIBUTION_NOTIFICATION_UNSIGNED",
    ATTRIBUTION_NOTIFICATION: "ATTRIBUTION_NOTIFICATION",
    ORDER: "ORDER",
    ORDER_SIGNED: "ORDER_SIGNED",
    OFFER: "OFFER",
};

export function getDocumentByType(documents, priorityTypes) {
    for (const type of priorityTypes) {
        const found = documents.find(doc => doc.type === type);
        if (found) return found;
    }
    return null;
}
